import { render, staticRenderFns } from "./welfarePage.vue?vue&type=template&id=ea76a39a&scoped=true"
import script from "./welfarePage.vue?vue&type=script&lang=js"
export * from "./welfarePage.vue?vue&type=script&lang=js"
import style0 from "./welfarePage.vue?vue&type=style&index=0&id=ea76a39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea76a39a",
  null
  
)

export default component.exports